import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { ReservaService } from '../../services/reserva.service';
import { HorarioService } from '../../services/horario.service';
import { Reserva } from '../../interfaces/utilidades/reservas.interface';
import {NgForOf, NgIf} from '@angular/common';


@Component({
  selector: 'app-editar-reserva',
  templateUrl: './editar-reserva.component.html',
  imports: [
    ReactiveFormsModule,
    NgForOf,
    NgIf
  ],
  styleUrls: ['./editar-reserva.component.css']
})
export class EditarReservaComponent implements OnInit {
  @Input() reservaId!: number;
  @Output() updateSuccess = new EventEmitter<void>();
  reserva!: Reserva;
  @Output() errorOccurred = new EventEmitter<string>();
  editarReservaForm: FormGroup = new FormGroup({});
  horariosDisponibles: any[] = [];
  selectedHorarios: number[] = [];

  constructor(
    private fb: FormBuilder,
    private reservaService: ReservaService,
    private horarioService: HorarioService,
  ) {}



ngOnInit(): void {
    if (this.reservaId) {
      this.reservaService.getReservaById(this.reservaId).subscribe(
        (data) => {
          this.reserva = data;
          this.initializeForm();
       this.loadHorariosDisponibles(this.reserva.fecha_reserva, this.reserva.campo.id_campo);
        },
        (error) => {
        //  console.error('Error fetching reservation:', error);
        }
      );
    }
  }

  initializeForm(): void {
    this.editarReservaForm = this.fb.group({
      fecha_reserva: [this.reserva.fecha_reserva, Validators.required],
    });
  }

  loadHorariosDisponibles(fecha: string, idCampo: number): void {
    this.horarioService.verificarHorariosDisponiblesEditar(this.reservaId,fecha, idCampo).subscribe(
      (data) => {
        this.horariosDisponibles = data;
      },
      (error) => {
        //console.error('Error loading schedules:', error);
      }
    );
  }

  toggleHorario(horarioId: number): void {
    const index = this.selectedHorarios.indexOf(horarioId);
    if (index > -1) {
      this.selectedHorarios.splice(index, 1);
    } else {
      this.selectedHorarios.push(horarioId);
    }
  }

  onSubmit(): void {
    if (this.editarReservaForm.valid) {
      if (!this.reserva.persona_juridica?.id_persona_juridica) {
        //console.error('id_persona_juridica cannot be null.');
        return;
      }

      const updatedFields: Partial<Reserva> = {
        id_persona_juridica: this.reserva.persona_juridica.id_persona_juridica,
        id_campo: this.reserva.campo.id_campo,
        id_estado: this.reserva.estado.id,
        fecha_reserva: this.reserva.fecha_reserva,
        horario_inicio: this.reserva.horario_inicio,
        horario_fin: this.reserva.horario_fin,
        descuento: this.reserva.descuento,
        motivo_descuento: this.reserva.motivo_descuento,
        id_tipo_dia: this.reserva.tipo_dia.id,
        horarios: this.selectedHorarios // Actualizar solo los horarios
      };

      this.reservaService.updateReserva({ id: this.reservaId, ...updatedFields })
        .subscribe(
          (response) => {
          //  console.log('Reservation updated successfully:', response);
            this.updateSuccess.emit(); // Emit event on successful update
          },
          (error) => {
            this.errorOccurred.emit('Error updating reservation');
          }
        );
    } else {
      this.errorOccurred.emit('Invalid form data');
    }
  }
  updateEstadoNoPagado(): void {
    this.reservaService.updateEstadoNoPagado(this.reservaId).subscribe(
      (response) => {
    //    console.log('Estado actualizado a No Pagado:', response);
        this.updateSuccess.emit(); // Emit event on successful update
      },
      (error) => {
        this.errorOccurred.emit('Error al actualizar');
      }
    );
  }

}
